// @Version: 1.0.0
import { Component } from '@angular/core';
import { TRANSLATE_PATH } from '../../shared.model';

@Component({
   selector: 'app-not-found',
   templateUrl: './not-found.component.html',
   standalone: false
})
export class NotFoundComponent {

   public TRANSLATE_PATH = TRANSLATE_PATH; 

   constructor () {}
}
